
import { reactive, ref, toRefs, unref, onMounted, defineComponent } from "vue";
//引入vue方法
import { ElConfigProvider } from "element-plus";
import type { ElForm } from "element-plus";

//中文包
import { useRouter } from "vue-router";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { getApply, delApply, putApply } from "@/api/backstage";
import { ElMessage } from "element-plus";
import { getEnum } from "@/api/index";
type FormInstance = InstanceType<typeof ElForm>;

export default defineComponent({
  name: "代理申请",
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
  },
  setup() {
    let locale = zhCn;
    const router = useRouter();
    const dataMap: any = reactive({
      productType:'',
      types:'',
      ruleFormRef: ref<FormInstance>(),

      drawer: false,
      newsInfo: "",

      tableData: [],
      total: 0,
      time: "",
      form: {
        keyword: "",
        productType: "",
        dealStatus: "",
        agencyStatus: "",
        pageNum: 1,
        pageSize: 10,
      },
      async getList() {
        const data = await getApply(this.form);
        for (const item of data.data.list) {
          if (item.fileName) {
            item.fileUrl = localStorage.getItem("fileUrel") + item.fileName;
          }
          item.dealStatus === 2 ? (item.dealStatus = false) : (item.dealStatus = true);
        }
        dataMap.tableData = data?.data.list ?? [];
        dataMap.total = data?.data.total ?? 0;
      },

      async getProType() {
        dataMap.productType = {};
        const menus = await getEnum("PRODUCT");
        for (const item of menus.data) {
          dataMap.productType[item.enumKey] = item;
        }
      },
      async getTyp() {
        dataMap.types = {};
        const menus = await getEnum("AGENCY");
        for (const item of menus.data) {
          dataMap.types[item.enumKey] = item;
        }
      },

      async putApply(row: any) {
        row.dealStatus ?row.dealStatus =1 :row.dealStatus=2;
        const res = await putApply(row);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          dataMap.getList();
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
    
      async delDataList(ids: any) {
        const baseId = { id: ids };
        const res = await delApply(baseId);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          dataMap.getList();
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
 
    });
 

    const resetForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.resetFields();
      dataMap.getList();
    };

    const handleSizeChange = (val: number) => {
      dataMap.form.pageSize = val;
      dataMap.getList();
    };
    const handleCurrentChange = (val: number) => {
      dataMap.form.pageNum = val;
      dataMap.getList();
    };

    const onSubmit = () => {
      dataMap.getList();
    };
    const confirmEvent = (row: any, index: any) => {
      dataMap.delDataList(row.id);
    };
    
    onMounted(() => {
      dataMap.getList();
      dataMap.getProType();
      dataMap.getTyp();
    });

    return {
      locale,
      close,
      resetForm,
      router,
      onSubmit,
      confirmEvent,
      handleSizeChange,
      handleCurrentChange,
      ...toRefs(dataMap),
    };
  },
});
